import styles from './styles.scss';
import cn from 'classnames';
import { BlockProps, Block } from './block';

export type ColumnType = 'two' | 'three' | 'four';
const COL_2: ColumnType = 'two';
const COL_3: ColumnType = 'three';
const COL_4: ColumnType = 'four';

export const ColumnCount = {
  Two: COL_2,
  Three: COL_3,
  Four: COL_4
};

interface Props extends BlockProps {
  onlyShowFirstOnWrap?: boolean;
  gutters?: boolean;
  columns?: ColumnType;
}

export const ColumnLayout = ({
  children,
  className,
  columns = ColumnCount.Three,
  onlyShowFirstOnWrap = false,
  gutters = false
}: Props) => (
  <Block
    appearance="secondary"
    className={cn(
      styles.columnLayout,
      {
        [styles.col2]: columns === COL_2,
        [styles.col3]: columns === COL_3,
        [styles.col4]: columns === COL_4,
        [styles.hide]: onlyShowFirstOnWrap,
        [styles.gutters]: gutters
      },
      className
    )}
  >
    {children}
  </Block>
);
